import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  InfoBorderIconComponent,
  CloseSquareIconComponent,
} from '@kuiper/icons';
import { ModalServiceService } from '../../../../ui-components/lib/modal/modal-service.service';

@Component({
  selector: 'lib-confirmation-popup',
  imports: [InfoBorderIconComponent, CloseSquareIconComponent, TranslocoPipe],
  templateUrl: './confirmation-popup.component.html',
  styleUrl: './confirmation-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConfirmationPopupComponent {
  private readonly modalService = inject(ModalServiceService);
  title = input<string>('');
  description = input<string>('');
  confirmButton = input<{ label: string; action: () => void }>();
  cancelButton = input<string>();
  status = input<'primary' | 'error'>('primary');
  disable = input<boolean>(false);

  bgClass = computed(() => {
    if (this.status() === 'error') {
      return 'bg-destructive';
    } else {
      return 'bg-primary';
    }
  });

  close() {
    this.modalService.modalContent.set({
      isOpen: false,
    });
  }
}
